'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubmitButton = exports.Button = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ramda = require('ramda');

require('./Button.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var concatAll = (0, _ramda.unapply)((0, _ramda.reduce)(_ramda.concat, []));

var mkButton = function mkButton(buttonType) {
  return function (_ref) {
    var children = _ref.children,
        className = _ref.className,
        type = _ref.type,
        large = _ref.large,
        otherProps = _objectWithoutProperties(_ref, ['children', 'className', 'type', 'large']);

    var classes = concatAll(['btn-d', type + '-btn'], large ? ['lrg-btn'] : [], className ? [className] : []);

    return _react2.default.createElement(
      'button',
      _extends({
        type: buttonType
      }, otherProps, {
        className: classes.join(' ') }),
      children
    );
  };
};

var Button = exports.Button = mkButton('button');
var SubmitButton = exports.SubmitButton = mkButton('submit');

Button.propTypes = SubmitButton.propTypes = {
  type: _propTypes2.default.oneOf(['primary', 'success', 'info', 'default', 'warning', 'danger', 'solid-primary']).isRequired,
  large: _propTypes2.default.bool
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cjdev/visual-stack/lib/components/Button.js
// module id = 82
// module chunks = 0